import { render, staticRenderFns } from "./card.modalForm.vue?vue&type=template&id=4a0a8f7a&"
import script from "./card.modalForm.vue?vue&type=script&lang=js&"
export * from "./card.modalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports